export const GET_BANNERS = "GET_BANNERS";
export const CREATE_BANNERS = "CREATE_BANNERS";
export const UPDATE_BANNERS = "UPDATE_BANNERS";
export const BANNERS_FAILURE = "BANNERS_FAILURE";
export const BANNERS_SUCCESS = "BANNERS_SUCCESS";
export const DELETE_BANNER = "DELETE_BANNER";
export const DELETE_BANNER_SUCCESS = "DELETE_BANNER_SUCCESS";
export const DELETE_BANNER_FAILURE = "DELETE_BANNER_FAILURE";

export const get_Banners = (payload) => ({
  type: GET_BANNERS,
  payload,
});
export const create_Banners = (payload) => ({
  type: CREATE_BANNERS,
  payload,
});

export const update_Banners = (payload) => ({
  type: UPDATE_BANNERS,
  payload,
});
export const create_Banners_fail = (payload) => ({
  type: BANNERS_FAILURE,
  payload,
});

export const create_Banners_success = (payload) => ({
  type: BANNERS_SUCCESS,
  payload,
});

export const deleteBanner = (payload) => ({
  type: DELETE_BANNER,
  payload,
});
export const deleteBannerSuccess = (payload) => ({
  type: DELETE_BANNER_SUCCESS,
  payload,
});
export const deleteBannerFailure = (payload) => ({
  type: DELETE_BANNER_FAILURE,
  payload,
});
